import { Stack, SvgIcon, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { initiativeWizard } from "../../../styles/styles";

const Ending = () => {
  const [onError] = useState(false);
  const { t } = useTranslation();

  return (
    <Stack
      spacing={1}
      sx={{  width: "100%", padding: "2rem", height:"100%" }}
    >
      {onError ? (
        <Box sx={initiativeWizard.step5.error.box}>
          <SvgIcon sx={initiativeWizard.step5.error.icon}>
            <path d="M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9M11,15H13V17H11V15M11,7H13V13H11V7" />
          </SvgIcon>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t("initiative.wizard.step5.body.error")}
          </Typography>
          
          <Typography variant="body1">{/*FIXME: handling dell'errore*/} Error Code 403</Typography>
        </Box>
      ) : (
        <Box sx={initiativeWizard.step5.success.box}>
          <SvgIcon sx={initiativeWizard.step5.success.icon}>
            <path d="M23 12L20.6 9.2L20.9 5.5L17.3 4.7L15.4 1.5L12 3L8.6 1.5L6.7 4.7L3.1 5.5L3.4 9.2L1 12L3.4 14.8L3.1 18.5L6.7 19.3L8.6 22.5L12 21L15.4 22.5L17.3 19.3L20.9 18.5L20.6 14.8L23 12M18.7 16.9L16 17.5L14.6 19.9L12 18.8L9.4 19.9L8 17.5L5.3 16.9L5.5 14.1L3.7 12L5.5 9.9L5.3 7.1L8 6.5L9.4 4.1L12 5.2L14.6 4.1L16 6.5L18.7 7.1L18.5 9.9L20.3 12L18.5 14.1L18.7 16.9M16.6 7.6L18 9L10 17L6 13L7.4 11.6L10 14.2L16.6 7.6Z" />
          </SvgIcon>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t("initiative.wizard.step5.body.success")}
          </Typography>
        </Box>
      )}
    </Stack>
  );
};

export default Ending;
